module.exports = __webpack_public_path__ + "static/media/april.c056f5ae.png";